import { Component, Injector, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { appearance } from 'src/app/config/appearance';
import { SecurityDataService } from '../../../../submodules/angular-common/security-data.service';
import { BaseView } from '../../base-view';
import { ChangePasswordDialogComponent } from '../../security/change-password/change-password-dialog/change-password-dialog.component';

@Component({
  selector: 'app-profile-section',
  templateUrl: './profile-section.component.html',
  styleUrls: ['./profile-section.component.scss'],
})
export class ProfileSectionComponent extends BaseView {

  constructor(
    protected _injector: Injector,
    public securityDataService: SecurityDataService
  ) {
    super(_injector)
  }

  openChangePasswordDialog() {
    this._injector.get(MatDialog).open(ChangePasswordDialogComponent, 
                                       { disableClose: true,
                                         width: '500px',
                                         maxWidth: '100vw' });
  }

  navigateToLogin() {
    this._injector.get(Router).navigate(['/login']);
  }
}
